jQuery(document).on('gform_post_render', function(event, form_id, current_page){

    // code to trigger on form or form page render

});

(function(window, document, $, undefined){

    'use strict';
    window.animation = {};

    /* animation.init = function() {
         animation.autogrow();
     }
 */


    //$(document).on( 'ready', animation.init );

    jQuery(document).on('gform_post_render', function() {

        $('textarea').autogrow({vertical: true, horizontal: true, onInitialize: false});
        //$('.textarea.large').autogrow({vertical: true, horizontal: false});

    } );


})(window, document, jQuery);